import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';
import { ServicePathName, ServiceRoute } from '@/modules/ta/service/service.constants';
import { ServiceOverviewRouteConfig } from '@/modules/ta/service/ServiceOverviewRouteConfig';
import { ServiceDrilldownRouteConfig } from '@/modules/ta/service/ServiceDrilldownRouteConfig';

export const router = [
  PageRouteConfig.factory(
    {
      path: `/${ServiceRoute.MARKETPLACE}`,
      name: ServicePathName.MARKETPLACE,
      component: () =>
        import(/* webpackChunkName: "marketplace-page" */ './pages/ConnectServicesPage.vue'),
    },
    Module.SERVICE
  ),
  PageRouteConfig.factory(
    {
      path: `/${ServiceRoute.SERVICE}/manage`,
      name: ServicePathName.SERVICEMANAGE,
      component: () =>
        import(
          /* webpackChunkName: "servicemanage-page" */ '@/modules/legacy/connect/pages/ConnectPage.vue'
        ),
    },
    Module.SERVICE
  ),
  PageRouteConfig.factory(
    {
      path: `/${ServiceRoute.SERVICE}/manage/connections/:id`,
      name: ServicePathName.SERVICEMANAGE_SHOWCONNECTION,
      component: () =>
        import(
          /* webpackChunkName: "servicemanage-page" */ '@/modules/legacy/connect/pages/ConnectPage.vue'
        ),
    },
    Module.SERVICE
  ),
  PageRouteConfig.factory(
    {
      path: `/${ServiceRoute.SERVICE}/manage/:id`,
      name: ServicePathName.SERVICEMANAGE_OPEN, // It's called service.manage.open in angular, so following same name here as well.
      component: () =>
        import(
          /* webpackChunkName: "servicemanage-page" */ '@/modules/legacy/connect/pages/ConnectPage.vue'
        ),
    },
    Module.SERVICE
  ),
  PageRouteConfig.factory(
    {
      path: `/${ServiceRoute.SERVICE}/mappings/:error?`,
      name: ServicePathName.SERVICEMAPPINGS, // It's called service.mappings.error in angular, so following same name here as well.
      component: () =>
        import(
          /* webpackChunkName: "servicemappings-page" */ '@/modules/legacy/connect/pages/ServiceMappingsPage.vue'
        ),
    },
    Module.SERVICE
  ),
  ServiceOverviewRouteConfig.factory(
    {
      path: `/${ServiceRoute.OVERVIEW}`,
      name: ServicePathName.SERVICEOVERVIEW,
      component: () =>
        import(/* webpackChunkName: "serviceoverview-page" */ './pages/ServiceOverviewPage.vue'),
    },
    Module.SERVICE
  ),
  PageRouteConfig.factory(
    {
      path: `/${ServiceRoute.SERVICESETTINGS}`,
      name: ServicePathName.SERVICESETTINGS,
      component: () =>
        import(
          /* webpackChunkName: "servicesettings-form-page" */ './pages/ServiceSettingFormPage.vue'
        ),
    },
    Module.SERVICESETTINGS
  ),
  ServiceDrilldownRouteConfig.factory(
    {
      path: `/${ServiceRoute.SERVICES}/drilldown/:id/:dataview?/:entityid?`,
      name: ServicePathName.SERVICEDRILLDOWN,
      component: () =>
        import(/* webpackChunkName: "servicedrilldown-page" */ './pages/ServiceDrilldownPage.vue'),
    },
    Module.SERVICE
  ),
  ServiceDrilldownRouteConfig.factory(
    {
      path: `/${ServiceRoute.SERVICES}/drilldown/:id/:dataview/client_id/:client_id`,
      name: ServicePathName.SERVICEDRILLDOWN_CLIENT,
      component: () =>
        import(/* webpackChunkName: "servicedrilldown-page" */ './pages/ServiceDrilldownPage.vue'),
    },
    Module.SERVICE
  ),
];
